export default {
  placeholderTitle: {
    id: 'review_display_best_placeholder_title',
    defaultMessage: 'They bought on Back Market',
  },
  seeMore: {
    id: 'review_display_best_see_more',
    defaultMessage: 'See more reviews',
  },
}
